import { pdfjs } from 'react-pdf'

import { Environment } from 'config/environment'

export default (_environment: Environment) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker@${pdfjs.version}.min.js`
}
